'use strict'

import FlexWrapper from '../FlexWrapper'
import MessageText from '../MessageText'
import RetractablePanel from '../RetractablePanel'
import Loader from '../Loader'

import PropTypes from 'prop-types'

import React from 'react'
import './DetailsPage.less'
import classNames from 'classnames'

const COMPONENT_CLASS = 'nmc-details-page'

class DetailsPage extends React.Component {

  isLoading () {
    return this.props.hasOwnProperty('loading') && this.props.loading !== false
  }

  getMessage () {
    if (this.props.successMessage) {
      return (
        <MessageText>{this.props.successMessage}</MessageText>
      )
    } else if (this.props.errorMessage) {
      return (
        <MessageText isSuccess={false}>{this.props.errorMessage}</MessageText>
      )
    }
    return (<MessageText placeholder />)
  }

  getLeftSideContent () {
    if (this.props.leftSide) {
      return this.props.leftSide
    } else {
      return (
        <FlexWrapper>
          <div className='nmc-details-page-left-side-top-fields'>
            {this.props.leftSideTopFields}
          </div>
          <div className='nmc-details-page-left-side-bottom-fields'>
            {this.props.leftSideBottomFields}
          </div>
          <div className='nmc-details-page-left-side-bottom-buttons-holder'>
            {this.getMessage()}
            <div className='nmc-details-page-left-side-bottom-buttons'>
              {this.props.leftSideButtons}
            </div>
          </div>
        </FlexWrapper>
      )
    }
  }

  render () {
    const isLoading = this.isLoading()
    const classes = classNames(COMPONENT_CLASS, {
      'gray-out': isLoading
    })
    return (
      <div className={classes}>
        {isLoading && <Loader />}
        <RetractablePanel {...this.props} >
          {this.getLeftSideContent()}
        </RetractablePanel>
        {this.props.children}
      </div>
    )
  }
}

DetailsPage.DEFAULT_CLASS = COMPONENT_CLASS

DetailsPage.PropTypes = {
  loading: PropTypes.bool,
  leftSideTopFields: PropTypes.array,
  leftSideBottomFields: PropTypes.array,
  leftSideButtons: PropTypes.array,
  leftSide: PropTypes.element,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string
}

DetailsPage.defaultProps = {
  leftSideTopFields: [],
  leftSideBottomFields: [],
  leftSideButtons: []
}

export default DetailsPage



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/DetailsPage/index.js